import * as React from "react"
import {
  MainContainer,
  LeftContainer,
  PlayButton,
  RightContainer,
  RightInnerContainer,
  AboutHeading,
  AboutSubheading,
} from "./aboutStyles"

import Fade from "react-reveal/Fade"

const AboutSection = () => {
  return (
    <MainContainer>
      <RightContainer>
        <RightInnerContainer>
          <Fade up>
            <AboutHeading>About Conference</AboutHeading>
          </Fade>
          <Fade up>
            <AboutSubheading>
              React state management GraphQL React TypeScript Mobx and
              mobx-state-tree Micro-frontend Server-Side Rendering Design System
              Creating / Working with Hooks React Jest unit testing General
              design patterns Real-World SPAs & React Web Apps React
              Alternatives Class components, Defining and rendering a component
              Prop Validation Testing components Offline events are gone for
              some time, but the tech world doesn't slow down. React JS
              community needs the platform to share the latest updates and use
              cases to improve coding skills and get architectural insights. We
              aim to provide an online event for React JS geeks from all over
              the world to share what's new in domain. Geekle has the unique
              experience to gather huge tech summits with 11'000+ attendees with
              95% of free users registered in different tech domains. Now we
              hope to make something world never seen before for the React JS
              Community. See ya'll!
            </AboutSubheading>
          </Fade>

          {/* <button
              style={{ marginTop: "20px" }}
              class="glow-on-hover"
              type="button"
            >
              REGISTER NOW
            </button> */}
        </RightInnerContainer>
      </RightContainer>
    </MainContainer>
  )
}

export default AboutSection
